import './src/main.css'
import BorderBox2 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox2.name, BorderBox2)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox2/index.js